const modals = document.querySelectorAll('[data-dialog-open]');
const closeButton = document.querySelectorAll(".modal__close");

modals.forEach(function (modal) {
    modal.addEventListener('click', function () {
        const dialog = document.getElementById(this.dataset.dialogOpen);
        dialog.showModal();
        document.body.classList.add('modal-open');

        // Logic for playing video
        const videoContainer = document.querySelectorAll('.modal-video-container');
        if (videoContainer.length > 0) {
            const videoId = videoContainer[0].id;
            const videoEmbed =
                '<div class="embed-responsive-16by9"><iframe src="//www.youtube-nocookie.com/embed/'
                + videoId
                + '?autoplay=1" width="560" height="315" frameborder="0" allowfullscreen></iframe></div>';
            videoContainer[0].innerHTML = videoEmbed;
        }
    });
});

closeButton.forEach(function (button) {
    button.addEventListener('click', function () {
        const dialog = document.getElementById(this.dataset.dialogClose);
        dialog.close();
        document.body.classList.remove('modal-open');

        // Logic for removing video
        const videoContainer = document.querySelectorAll('.modal-video-container');
        if (videoContainer.length > 0) {
            const videoId = videoContainer[0].id;
            videoContainer[0].innerHTML = '';     
        }
    });
});
